// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type BrregAddress = {
  readonly __typename?: 'BrregAddress';
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly postalcode: Scalars['String'];
  readonly street: Scalars['String'];
};

export type BrregCompany = {
  readonly __typename?: 'BrregCompany';
  readonly address: BrregAddress;
  readonly bankrupt: Scalars['Boolean'];
  readonly employeeCount: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly incorporation: Scalars['String'];
  readonly name: Scalars['String'];
  readonly signatories: BrregSignatories;
};

export type BrregPerson = {
  readonly __typename?: 'BrregPerson';
  readonly dateofbirth: Scalars['String'];
  readonly name: Scalars['String'];
  readonly role: Maybe<Scalars['String']>;
};

export type BrregSignatories = {
  readonly __typename?: 'BrregSignatories';
  readonly others: ReadonlyArray<BrregPerson>;
  readonly required: ReadonlyArray<BrregPerson>;
  readonly requiredNumberOfOthers: Scalars['Int'];
};

export type CompanyNameCheck = {
  readonly __typename?: 'CompanyNameCheck';
  readonly companyTypeOk: Scalars['Boolean'];
  /** Is not the name of an existing company */
  readonly existingNameOk: Scalars['Boolean'];
  /** Overall OK. If this is true, all others are too. */
  readonly isOk: Scalars['Boolean'];
  readonly lengthOk: Scalars['Boolean'];
  /** Is not the name of a country, municipality or county */
  readonly properNameOk: Scalars['Boolean'];
  /** Contains valid characters */
  readonly validSymbolsOk: Scalars['Boolean'];
};

export type CompanyType =
  | 'GOODS'
  | 'INVESTING'
  | 'OTHER'
  | 'SERVICES'
  | 'UNSPECIFIED';

export type ConfirmedEvent = FoundingEvent & {
  readonly __typename?: 'ConfirmedEvent';
  readonly signerURLs: ReadonlyArray<MaSignerUrl>;
  readonly timestamp: Scalars['String'];
};

export type FoundingCompany = {
  readonly __typename?: 'FoundingCompany';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly orgId: Scalars['String'];
};

export type FoundingDoneEvent = FoundingEvent & {
  readonly __typename?: 'FoundingDoneEvent';
  readonly orgId: Scalars['String'];
  readonly timestamp: Scalars['String'];
};

export type FoundingEvent = {
  readonly timestamp: Scalars['String'];
};

export type FoundingFounder = {
  readonly __typename?: 'FoundingFounder';
  /** id in the people or companies */
  readonly owner: Scalars['ID'];
  readonly shares: Scalars['Int'];
};

export type FoundingOwner = {
  readonly __typename?: 'FoundingOwner';
  /** id of person or company */
  readonly id: Scalars['ID'];
  /** number of shares owned */
  readonly shares: Scalars['Int'];
  /** people in the Person list */
  readonly signatories: ReadonlyArray<Scalars['ID']>;
};

export type FoundingPerson = {
  readonly __typename?: 'FoundingPerson';
  readonly address: Scalars['String'];
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly mobile: Scalars['String'];
  readonly name: Scalars['String'];
  readonly pNum: Scalars['String'];
  readonly postalCode: Scalars['String'];
  /** note: server fills in this! */
  readonly postalPlace: Scalars['String'];
};

export type FoundingRole = {
  readonly __typename?: 'FoundingRole';
  /** id in the people array */
  readonly person: Scalars['ID'];
  readonly role: Role;
};

export type FoundingSignatory = {
  readonly __typename?: 'FoundingSignatory';
  /** persons in the People array */
  readonly person: Scalars['ID'];
  /** id in the people or companies */
  readonly signsFor: Scalars['ID'];
};

/**
 * Full representation of a founding. What the client will
 * send to the server in order to confirm a founding.
 */
export type FoundingSpecification = {
  readonly __typename?: 'FoundingSpecification';
  readonly activityCategoryId: Maybe<Scalars['ID']>;
  readonly activityId: Maybe<Scalars['ID']>;
  readonly address: Scalars['String'];
  readonly capital: Scalars['Int'];
  readonly companies: ReadonlyArray<FoundingCompany>;
  readonly companyType: Maybe<CompanyType>;
  readonly formOwner: Scalars['ID'];
  readonly foundingDate: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly industryCode: Maybe<Scalars['ID']>;
  readonly name: Scalars['String'];
  readonly orgTransfer: Maybe<OrgTransfer>;
  readonly owners: ReadonlyArray<FoundingOwner>;
  readonly people: ReadonlyArray<FoundingPerson>;
  readonly postalCode: Scalars['String'];
  readonly purpose: Scalars['String'];
  readonly roles: ReadonlyArray<FoundingRole>;
  readonly shareCount: Scalars['Int'];
  readonly verbosePurpose: Scalars['String'];
  readonly willHaveEmployees: WillHaveEmployees;
};

export type InputCompany = {
  readonly id: Scalars['ID'];
  readonly orgId: Scalars['String'];
};

/**
 * Full representation of a founding. What the client will
 * send to the server in order to confirm a founding.
 */
export type InputFoundingSpecification = {
  readonly activityCategoryId?: InputMaybe<Scalars['ID']>;
  readonly activityId?: InputMaybe<Scalars['ID']>;
  readonly address: Scalars['String'];
  readonly capital: Scalars['Int'];
  readonly companies: ReadonlyArray<InputCompany>;
  readonly companyType?: InputMaybe<CompanyType>;
  readonly formOwner: Scalars['ID'];
  readonly foundingDate: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly industryCode?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly orgTransfer?: InputMaybe<InputOrgTransfer>;
  readonly owners: ReadonlyArray<InputOwner>;
  readonly people: ReadonlyArray<InputPerson>;
  readonly postalCode: Scalars['String'];
  readonly purpose: Scalars['String'];
  readonly roles: ReadonlyArray<InputRole>;
  readonly shareCount: Scalars['Int'];
  readonly verbosePurpose: Scalars['String'];
  readonly willHaveEmployees: WillHaveEmployees;
};

export type InputOrgTransfer = {
  readonly orgId: Scalars['String'];
  readonly orgName: Scalars['String'];
  readonly signatory: Scalars['ID'];
};

export type InputOwner = {
  /** id of person or company */
  readonly id: Scalars['ID'];
  /** number of shares owned */
  readonly shares: Scalars['Int'];
  /** people in the Person list */
  readonly signatories: ReadonlyArray<Scalars['ID']>;
};

export type InputPerson = {
  readonly address: Scalars['String'];
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly mobile: Scalars['String'];
  readonly name: Scalars['String'];
  readonly pNum: Scalars['String'];
  readonly postalCode: Scalars['String'];
};

export type InputRole = {
  /** id in the people array */
  readonly person: Scalars['ID'];
  readonly role: Role;
};

export type MaAccountingSelection = 'FIKEN' | 'OTHER' | 'UNSET';

export type MaBankSelection =
  | 'FOLIO'
  | 'FOLIO_AML_COMPLETE'
  | 'FOLIO_ONBOARDED'
  | 'FOLIO_REJECTED'
  | 'OTHER'
  | 'OTHER_NAGGED'
  | 'UNSET';

export type MaFounding = {
  readonly __typename?: 'MaFounding';
  readonly accountingSelection: Maybe<MaAccountingSelection>;
  readonly bankSelection: Maybe<MaBankSelection>;
  readonly canUpdatePersonDetails: Scalars['Boolean'];
  readonly documentURL: Maybe<Scalars['String']>;
  readonly estimatedProcessingTimeToGoBrreg: Maybe<Scalars['Int']>;
  readonly events: ReadonlyArray<FoundingEvent>;
  readonly foundingDetails: Maybe<FoundingSpecification>;
  readonly id: Scalars['ID'];
  readonly orgTransferSignerURLs: ReadonlyArray<MaSignerUrl>;
  readonly signerURLs: ReadonlyArray<MaSignerUrl>;
  readonly signingStatus: MaSigningStatus;
  readonly uploadReceiptURL: Maybe<Scalars['String']>;
  readonly virksomhetsInfoSignerURLs: ReadonlyArray<MaSignerUrl>;
};

export type MaSignerUrl = {
  readonly __typename?: 'MaSignerURL';
  readonly id: Scalars['ID'];
  readonly signed: Scalars['Boolean'];
  readonly url: Scalars['String'];
};

export type MaSigningStatus = 'CONFIRMED' | 'OPEN' | 'SIGNED' | 'SUBMITTED';

export type Mutation = {
  readonly __typename?: 'Mutation';
  /**
   * Confirms that the founding is ready for signing.
   *
   * Possible error messages are:
   * - "check-folkeregisteret": Something in folkeregisteret is preventing the founding from proceeding
   * - "prekontroll-other": Something else went wrong in "prekontrollen"
   * -	"internal-error": An internal error that might be temporary. Retrying might work.
   */
  readonly maConfirm: Maybe<MaFounding>;
  readonly maGeneratePreview: Scalars['String'];
  readonly maReopen: Scalars['Boolean'];
  /**
   * No point returning anything from this usually, but mutations
   * can't be void I think, so return the status.
   */
  readonly maSave: MaSigningStatus;
  readonly maSendMail: Scalars['Boolean'];
  readonly maSendNewSigningEmail: Scalars['Boolean'];
  readonly maSetAccountingSelection: MaAccountingSelection;
  readonly maSetBankSelection: MaBankSelection;
  /**
   * Updates contact info for one person.
   * If the frontend state body is provided with the updated contact info, the change will persist across reopenings as well.
   * Do not update anything other than contact info in the frontend state, that can cause problems down the line
   */
  readonly maUpdateContactInfo: Scalars['Boolean'];
};

export type MutationMaConfirmArgs = {
  founding: InputFoundingSpecification;
};

export type MutationMaGeneratePreviewArgs = {
  founding: InputFoundingSpecification;
};

export type MutationMaReopenArgs = {
  id: Scalars['ID'];
};

export type MutationMaSaveArgs = {
  body: Scalars['String'];
  id: Scalars['ID'];
};

export type MutationMaSendMailArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type MutationMaSendNewSigningEmailArgs = {
  id: Scalars['ID'];
  personId: Scalars['ID'];
};

export type MutationMaSetAccountingSelectionArgs = {
  id: Scalars['ID'];
  selection: MaAccountingSelection;
};

export type MutationMaSetBankSelectionArgs = {
  id: Scalars['ID'];
  selection: MaBankSelection;
};

export type MutationMaUpdateContactInfoArgs = {
  body?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  personId: Scalars['ID'];
  phone: Scalars['String'];
};

/** Overtakelse av aktivitet */
export type OrgTransfer = {
  readonly __typename?: 'OrgTransfer';
  readonly orgId: Scalars['String'];
  readonly orgName: Scalars['String'];
  readonly signatory: Scalars['ID'];
};

export type PaymentReceiptReceivedEvent = FoundingEvent & {
  readonly __typename?: 'PaymentReceiptReceivedEvent';
  readonly timestamp: Scalars['String'];
};

export type PostalPlace = {
  readonly __typename?: 'PostalPlace';
  readonly city: Maybe<Scalars['String']>;
  readonly municipality: Maybe<Scalars['String']>;
  readonly postalCode: Scalars['String'];
};

export type ProcessingFoundingEvent = FoundingEvent & {
  readonly __typename?: 'ProcessingFoundingEvent';
  readonly estimatedDays: Scalars['Int'];
  readonly timestamp: Scalars['String'];
};

export type Query = {
  readonly __typename?: 'Query';
  readonly brregCheckCompanyName: CompanyNameCheck;
  readonly brregCompanies: ReadonlyArray<BrregCompany>;
  readonly brregCompany: Maybe<BrregCompany>;
  readonly brregInsufficientPurpose: Scalars['Boolean'];
  readonly brregProcessingTime: Maybe<Scalars['Int']>;
  readonly brregValidCompanyName: Scalars['Boolean'];
  readonly lookupPostalPlaces: ReadonlyArray<PostalPlace>;
  readonly maFounding: Maybe<MaFounding>;
  /**
   * Load editor state. Nullable. Null if there is no saved state?
   * rename this to 'ediorState' or 'snapshot' or something?
   */
  readonly maLoad: Maybe<Scalars['String']>;
};

export type QueryBrregCheckCompanyNameArgs = {
  name: Scalars['String'];
};

export type QueryBrregCompaniesArgs = {
  name: Scalars['String'];
};

export type QueryBrregCompanyArgs = {
  id: Scalars['ID'];
};

export type QueryBrregInsufficientPurposeArgs = {
  purpose: Scalars['String'];
};

export type QueryBrregValidCompanyNameArgs = {
  name: Scalars['String'];
};

export type QueryLookupPostalPlacesArgs = {
  postalCodes: ReadonlyArray<Scalars['String']>;
};

export type QueryMaFoundingArgs = {
  id: Scalars['ID'];
};

export type QueryMaLoadArgs = {
  id: Scalars['ID'];
};

export type RegisteringFoundingEvent = FoundingEvent & {
  readonly __typename?: 'RegisteringFoundingEvent';
  readonly reference: Scalars['String'];
  readonly submitter: Scalars['String'];
  readonly timestamp: Scalars['String'];
};

export type ReopenedEvent = FoundingEvent & {
  readonly __typename?: 'ReopenedEvent';
  readonly reason: Scalars['String'];
  readonly timestamp: Scalars['String'];
};

export type Role = 'BOARDMEMBER' | 'CEO' | 'CHAIR' | 'DEPUTY';

export type SigningAction = 'CANCELLED' | 'ERROR' | 'SIGNED';

export type SigningDoneEvent = FoundingEvent & {
  readonly __typename?: 'SigningDoneEvent';
  readonly timestamp: Scalars['String'];
};

export type SigningEvent = FoundingEvent & {
  readonly __typename?: 'SigningEvent';
  readonly action: SigningAction;
  readonly message: Maybe<Scalars['String']>;
  readonly timestamp: Scalars['String'];
  readonly user: Scalars['ID'];
};

export type SubmittedEvent = FoundingEvent & {
  readonly __typename?: 'SubmittedEvent';
  readonly timestamp: Scalars['String'];
  readonly user: Scalars['ID'];
};

export type WillHaveEmployees = 'NO' | 'YES' | 'YES_ME';

export type SaveEditorStateMutationVariables = Exact<{
  id: Scalars['ID'];
  body: Scalars['String'];
}>;

export type SaveEditorStateMutation = {
  readonly __typename?: 'Mutation';
  readonly maSave: MaSigningStatus;
};

export type LoadAppStateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type LoadAppStateQuery = {
  readonly __typename?: 'Query';
  readonly brregProcessingTime: number | null;
  readonly editorState: string | null;
  readonly maFounding: {
    readonly __typename?: 'MaFounding';
    readonly id: string;
    readonly signingStatus: MaSigningStatus;
    readonly documentURL: string | null;
    readonly uploadReceiptURL: string | null;
    readonly bankSelection: MaBankSelection | null;
    readonly accountingSelection: MaAccountingSelection | null;
    readonly canUpdatePersonDetails: boolean;
    readonly signerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly virksomhetsInfoSignerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly orgTransferSignerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly events: ReadonlyArray<
      | { readonly __typename: 'ConfirmedEvent'; readonly timestamp: string }
      | {
          readonly __typename: 'FoundingDoneEvent';
          readonly orgId: string;
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'PaymentReceiptReceivedEvent';
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'ProcessingFoundingEvent';
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'RegisteringFoundingEvent';
          readonly timestamp: string;
        }
      | { readonly __typename: 'ReopenedEvent'; readonly timestamp: string }
      | { readonly __typename: 'SigningDoneEvent'; readonly timestamp: string }
      | {
          readonly __typename: 'SigningEvent';
          readonly user: string;
          readonly action: SigningAction;
          readonly message: string | null;
          readonly timestamp: string;
        }
      | { readonly __typename: 'SubmittedEvent'; readonly timestamp: string }
    >;
    readonly foundingDetails: {
      readonly __typename?: 'FoundingSpecification';
      readonly id: string;
      readonly formOwner: string;
      readonly name: string;
      readonly foundingDate: string;
      readonly capital: number;
      readonly shareCount: number;
      readonly purpose: string;
      readonly companyType: CompanyType | null;
      readonly address: string;
      readonly postalCode: string;
      readonly willHaveEmployees: WillHaveEmployees;
      readonly people: ReadonlyArray<{
        readonly __typename?: 'FoundingPerson';
        readonly id: string;
        readonly name: string;
        readonly pNum: string;
        readonly address: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly email: string;
        readonly mobile: string;
      }>;
      readonly companies: ReadonlyArray<{
        readonly __typename?: 'FoundingCompany';
        readonly id: string;
        readonly orgId: string;
        readonly name: string;
      }>;
      readonly owners: ReadonlyArray<{
        readonly __typename?: 'FoundingOwner';
        readonly id: string;
        readonly shares: number;
        readonly signatories: ReadonlyArray<string>;
      }>;
      readonly roles: ReadonlyArray<{
        readonly __typename?: 'FoundingRole';
        readonly person: string;
        readonly role: Role;
      }>;
      readonly orgTransfer: {
        readonly __typename?: 'OrgTransfer';
        readonly orgName: string;
        readonly orgId: string;
      } | null;
    } | null;
  } | null;
};

export type ReopenSessionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ReopenSessionMutation = {
  readonly __typename?: 'Mutation';
  readonly maReopen: boolean;
};

export type ConfirmSessionMutationVariables = Exact<{
  founding: InputFoundingSpecification;
}>;

export type ConfirmSessionMutation = {
  readonly __typename?: 'Mutation';
  readonly maConfirm: {
    readonly __typename?: 'MaFounding';
    readonly id: string;
    readonly signingStatus: MaSigningStatus;
    readonly documentURL: string | null;
    readonly uploadReceiptURL: string | null;
    readonly bankSelection: MaBankSelection | null;
    readonly accountingSelection: MaAccountingSelection | null;
    readonly canUpdatePersonDetails: boolean;
    readonly signerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly virksomhetsInfoSignerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly orgTransferSignerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly events: ReadonlyArray<
      | { readonly __typename: 'ConfirmedEvent'; readonly timestamp: string }
      | {
          readonly __typename: 'FoundingDoneEvent';
          readonly orgId: string;
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'PaymentReceiptReceivedEvent';
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'ProcessingFoundingEvent';
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'RegisteringFoundingEvent';
          readonly timestamp: string;
        }
      | { readonly __typename: 'ReopenedEvent'; readonly timestamp: string }
      | { readonly __typename: 'SigningDoneEvent'; readonly timestamp: string }
      | {
          readonly __typename: 'SigningEvent';
          readonly user: string;
          readonly action: SigningAction;
          readonly message: string | null;
          readonly timestamp: string;
        }
      | { readonly __typename: 'SubmittedEvent'; readonly timestamp: string }
    >;
    readonly foundingDetails: {
      readonly __typename?: 'FoundingSpecification';
      readonly id: string;
      readonly formOwner: string;
      readonly name: string;
      readonly foundingDate: string;
      readonly capital: number;
      readonly shareCount: number;
      readonly purpose: string;
      readonly companyType: CompanyType | null;
      readonly address: string;
      readonly postalCode: string;
      readonly willHaveEmployees: WillHaveEmployees;
      readonly people: ReadonlyArray<{
        readonly __typename?: 'FoundingPerson';
        readonly id: string;
        readonly name: string;
        readonly pNum: string;
        readonly address: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly email: string;
        readonly mobile: string;
      }>;
      readonly companies: ReadonlyArray<{
        readonly __typename?: 'FoundingCompany';
        readonly id: string;
        readonly orgId: string;
        readonly name: string;
      }>;
      readonly owners: ReadonlyArray<{
        readonly __typename?: 'FoundingOwner';
        readonly id: string;
        readonly shares: number;
        readonly signatories: ReadonlyArray<string>;
      }>;
      readonly roles: ReadonlyArray<{
        readonly __typename?: 'FoundingRole';
        readonly person: string;
        readonly role: Role;
      }>;
      readonly orgTransfer: {
        readonly __typename?: 'OrgTransfer';
        readonly orgName: string;
        readonly orgId: string;
      } | null;
    } | null;
  } | null;
};

export type GeneratePreviewMutationVariables = Exact<{
  founding: InputFoundingSpecification;
}>;

export type GeneratePreviewMutation = {
  readonly __typename?: 'Mutation';
  readonly maGeneratePreview: string;
};

export type SendMailMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
}>;

export type SendMailMutation = {
  readonly __typename?: 'Mutation';
  readonly maSendMail: boolean;
};

export type UpdateContactInfoMutationVariables = Exact<{
  id: Scalars['ID'];
  personId: Scalars['ID'];
  email: Scalars['String'];
  phone: Scalars['String'];
  blob?: InputMaybe<Scalars['String']>;
}>;

export type UpdateContactInfoMutation = {
  readonly __typename?: 'Mutation';
  readonly maUpdateContactInfo: boolean;
};

export type SendNewSigningEmailMutationVariables = Exact<{
  id: Scalars['ID'];
  personId: Scalars['ID'];
}>;

export type SendNewSigningEmailMutation = {
  readonly __typename?: 'Mutation';
  readonly maSendNewSigningEmail: boolean;
};

export type PollFoundingStateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type PollFoundingStateQuery = {
  readonly __typename?: 'Query';
  readonly brregProcessingTime: number | null;
  readonly maFounding: {
    readonly __typename?: 'MaFounding';
    readonly id: string;
    readonly signingStatus: MaSigningStatus;
    readonly documentURL: string | null;
    readonly uploadReceiptURL: string | null;
    readonly bankSelection: MaBankSelection | null;
    readonly accountingSelection: MaAccountingSelection | null;
    readonly canUpdatePersonDetails: boolean;
    readonly signerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly virksomhetsInfoSignerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly orgTransferSignerURLs: ReadonlyArray<{
      readonly __typename?: 'MaSignerURL';
      readonly id: string;
      readonly url: string;
      readonly signed: boolean;
    }>;
    readonly events: ReadonlyArray<
      | { readonly __typename: 'ConfirmedEvent'; readonly timestamp: string }
      | {
          readonly __typename: 'FoundingDoneEvent';
          readonly orgId: string;
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'PaymentReceiptReceivedEvent';
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'ProcessingFoundingEvent';
          readonly timestamp: string;
        }
      | {
          readonly __typename: 'RegisteringFoundingEvent';
          readonly timestamp: string;
        }
      | { readonly __typename: 'ReopenedEvent'; readonly timestamp: string }
      | { readonly __typename: 'SigningDoneEvent'; readonly timestamp: string }
      | {
          readonly __typename: 'SigningEvent';
          readonly user: string;
          readonly action: SigningAction;
          readonly message: string | null;
          readonly timestamp: string;
        }
      | { readonly __typename: 'SubmittedEvent'; readonly timestamp: string }
    >;
    readonly foundingDetails: {
      readonly __typename?: 'FoundingSpecification';
      readonly id: string;
      readonly formOwner: string;
      readonly name: string;
      readonly foundingDate: string;
      readonly capital: number;
      readonly shareCount: number;
      readonly purpose: string;
      readonly companyType: CompanyType | null;
      readonly address: string;
      readonly postalCode: string;
      readonly willHaveEmployees: WillHaveEmployees;
      readonly people: ReadonlyArray<{
        readonly __typename?: 'FoundingPerson';
        readonly id: string;
        readonly name: string;
        readonly pNum: string;
        readonly address: string;
        readonly postalCode: string;
        readonly postalPlace: string;
        readonly email: string;
        readonly mobile: string;
      }>;
      readonly companies: ReadonlyArray<{
        readonly __typename?: 'FoundingCompany';
        readonly id: string;
        readonly orgId: string;
        readonly name: string;
      }>;
      readonly owners: ReadonlyArray<{
        readonly __typename?: 'FoundingOwner';
        readonly id: string;
        readonly shares: number;
        readonly signatories: ReadonlyArray<string>;
      }>;
      readonly roles: ReadonlyArray<{
        readonly __typename?: 'FoundingRole';
        readonly person: string;
        readonly role: Role;
      }>;
      readonly orgTransfer: {
        readonly __typename?: 'OrgTransfer';
        readonly orgName: string;
        readonly orgId: string;
      } | null;
    } | null;
  } | null;
};

export type CheckCompanyNameQueryVariables = Exact<{
  name: Scalars['String'];
}>;

export type CheckCompanyNameQuery = {
  readonly __typename?: 'Query';
  readonly brregCheckCompanyName: {
    readonly __typename?: 'CompanyNameCheck';
    readonly isOk: boolean;
    readonly validSymbolsOk: boolean;
    readonly lengthOk: boolean;
    readonly existingNameOk: boolean;
    readonly properNameOk: boolean;
    readonly companyTypeOk: boolean;
  };
};

export type CheckInsufficientPurposeQueryVariables = Exact<{
  purpose: Scalars['String'];
}>;

export type CheckInsufficientPurposeQuery = {
  readonly __typename?: 'Query';
  readonly brregInsufficientPurpose: boolean;
};

export type SetBankSelectionMutationVariables = Exact<{
  id: Scalars['ID'];
  selection: MaBankSelection;
}>;

export type SetBankSelectionMutation = {
  readonly __typename?: 'Mutation';
  readonly maSetBankSelection: MaBankSelection;
};

export type SetAccountingSelectionMutationVariables = Exact<{
  id: Scalars['ID'];
  selection: MaAccountingSelection;
}>;

export type SetAccountingSelectionMutation = {
  readonly __typename?: 'Mutation';
  readonly maSetAccountingSelection: MaAccountingSelection;
};

export type FoundingFieldsFragment = {
  readonly __typename?: 'MaFounding';
  readonly id: string;
  readonly signingStatus: MaSigningStatus;
  readonly documentURL: string | null;
  readonly uploadReceiptURL: string | null;
  readonly bankSelection: MaBankSelection | null;
  readonly accountingSelection: MaAccountingSelection | null;
  readonly canUpdatePersonDetails: boolean;
  readonly signerURLs: ReadonlyArray<{
    readonly __typename?: 'MaSignerURL';
    readonly id: string;
    readonly url: string;
    readonly signed: boolean;
  }>;
  readonly virksomhetsInfoSignerURLs: ReadonlyArray<{
    readonly __typename?: 'MaSignerURL';
    readonly id: string;
    readonly url: string;
    readonly signed: boolean;
  }>;
  readonly orgTransferSignerURLs: ReadonlyArray<{
    readonly __typename?: 'MaSignerURL';
    readonly id: string;
    readonly url: string;
    readonly signed: boolean;
  }>;
  readonly events: ReadonlyArray<
    | { readonly __typename: 'ConfirmedEvent'; readonly timestamp: string }
    | {
        readonly __typename: 'FoundingDoneEvent';
        readonly orgId: string;
        readonly timestamp: string;
      }
    | {
        readonly __typename: 'PaymentReceiptReceivedEvent';
        readonly timestamp: string;
      }
    | {
        readonly __typename: 'ProcessingFoundingEvent';
        readonly timestamp: string;
      }
    | {
        readonly __typename: 'RegisteringFoundingEvent';
        readonly timestamp: string;
      }
    | { readonly __typename: 'ReopenedEvent'; readonly timestamp: string }
    | { readonly __typename: 'SigningDoneEvent'; readonly timestamp: string }
    | {
        readonly __typename: 'SigningEvent';
        readonly user: string;
        readonly action: SigningAction;
        readonly message: string | null;
        readonly timestamp: string;
      }
    | { readonly __typename: 'SubmittedEvent'; readonly timestamp: string }
  >;
  readonly foundingDetails: {
    readonly __typename?: 'FoundingSpecification';
    readonly id: string;
    readonly formOwner: string;
    readonly name: string;
    readonly foundingDate: string;
    readonly capital: number;
    readonly shareCount: number;
    readonly purpose: string;
    readonly companyType: CompanyType | null;
    readonly address: string;
    readonly postalCode: string;
    readonly willHaveEmployees: WillHaveEmployees;
    readonly people: ReadonlyArray<{
      readonly __typename?: 'FoundingPerson';
      readonly id: string;
      readonly name: string;
      readonly pNum: string;
      readonly address: string;
      readonly postalCode: string;
      readonly postalPlace: string;
      readonly email: string;
      readonly mobile: string;
    }>;
    readonly companies: ReadonlyArray<{
      readonly __typename?: 'FoundingCompany';
      readonly id: string;
      readonly orgId: string;
      readonly name: string;
    }>;
    readonly owners: ReadonlyArray<{
      readonly __typename?: 'FoundingOwner';
      readonly id: string;
      readonly shares: number;
      readonly signatories: ReadonlyArray<string>;
    }>;
    readonly roles: ReadonlyArray<{
      readonly __typename?: 'FoundingRole';
      readonly person: string;
      readonly role: Role;
    }>;
    readonly orgTransfer: {
      readonly __typename?: 'OrgTransfer';
      readonly orgName: string;
      readonly orgId: string;
    } | null;
  } | null;
};

export const FoundingFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'FoundingFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MaFounding' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signingStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadReceiptURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'bankSelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingSelection' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'canUpdatePersonDetails' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signerURLs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'virksomhetsInfoSignerURLs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orgTransferSignerURLs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signed' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'events' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'SigningEvent' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'user' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'action' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FoundingDoneEvent' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'foundingDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formOwner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'foundingDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'capital' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shareCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purpose' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'willHaveEmployees' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'people' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pNum' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postalPlace' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mobile' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owners' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shares' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'signatories' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'person' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orgTransfer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orgName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'orgId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FoundingFieldsFragment, unknown>;
export const SaveEditorStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveEditorState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maSave' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'body' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'body' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SaveEditorStateMutation,
  SaveEditorStateMutationVariables
>;
export const LoadAppStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LoadAppState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brregProcessingTime' },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'editorState' },
            name: { kind: 'Name', value: 'maLoad' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'maFounding' },
            name: { kind: 'Name', value: 'maFounding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FoundingFields' },
                },
              ],
            },
          },
        ],
      },
    },
    ...FoundingFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<LoadAppStateQuery, LoadAppStateQueryVariables>;
export const ReopenSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReopenSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maReopen' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReopenSessionMutation,
  ReopenSessionMutationVariables
>;
export const ConfirmSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'founding' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InputFoundingSpecification' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maConfirm' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'founding' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'founding' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FoundingFields' },
                },
              ],
            },
          },
        ],
      },
    },
    ...FoundingFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  ConfirmSessionMutation,
  ConfirmSessionMutationVariables
>;
export const GeneratePreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GeneratePreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'founding' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'InputFoundingSpecification' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maGeneratePreview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'founding' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'founding' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneratePreviewMutation,
  GeneratePreviewMutationVariables
>;
export const SendMailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendMail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maSendMail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMailMutation, SendMailMutationVariables>;
export const UpdateContactInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateContactInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'personId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'blob' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maUpdateContactInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'personId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'personId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'body' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'blob' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateContactInfoMutation,
  UpdateContactInfoMutationVariables
>;
export const SendNewSigningEmailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'sendNewSigningEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'personId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maSendNewSigningEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'personId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'personId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendNewSigningEmailMutation,
  SendNewSigningEmailMutationVariables
>;
export const PollFoundingStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PollFoundingState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brregProcessingTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maFounding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'FoundingFields' },
                },
              ],
            },
          },
        ],
      },
    },
    ...FoundingFieldsFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  PollFoundingStateQuery,
  PollFoundingStateQueryVariables
>;
export const CheckCompanyNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckCompanyName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brregCheckCompanyName' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'name' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isOk' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'validSymbolsOk' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lengthOk' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'existingNameOk' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properNameOk' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyTypeOk' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckCompanyNameQuery,
  CheckCompanyNameQueryVariables
>;
export const CheckInsufficientPurposeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckInsufficientPurpose' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'purpose' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brregInsufficientPurpose' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'purpose' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'purpose' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CheckInsufficientPurposeQuery,
  CheckInsufficientPurposeQueryVariables
>;
export const SetBankSelectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetBankSelection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'selection' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MaBankSelection' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maSetBankSelection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'selection' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'selection' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetBankSelectionMutation,
  SetBankSelectionMutationVariables
>;
export const SetAccountingSelectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAccountingSelection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'selection' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MaAccountingSelection' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'maSetAccountingSelection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'selection' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'selection' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAccountingSelectionMutation,
  SetAccountingSelectionMutationVariables
>;
